export default "__VITE_ASSET__db0705d5__"